<template>
  <div id="app" @mousemove="idleReset">
    <Notification></Notification>
    <!-- header -->

    <!-- <div id="notification-banner">
      <p class="notification">
        Real-time, tick by tick data for Stock, Futures, and Commodities are now available! Please
        <a
          href="mailto: support@unibit.ai"
        >Contact us</a> for more details.
      </p>
      <button type="button" class="close close-banner" @click="closeNotification()">
        <v-icon name="x" style="color:white; width:1rem;"></v-icon>
      </button>
    </div>-->
    <!-- <Banner></Banner> -->
    <Navbar :pageClass="this.$route.name" v-if="showHeader()"></Navbar>

    <!-- application -->
    <transition name="fade">
      <router-view class="content"></router-view>
    </transition>
    <!-- log out count down -->
    <!-- <Modal id="UICountdown" :header="false">
      <div slot="body">
        <span id="CountdownContent">
          <h1 class="idle-header">You will be logged out!</h1>
          <p class="idle-info">
            You have been idle for longer than {{ idleTime / 60 }} minutes. You will be
            logged out in {{ UICountdown }} seconds.
          </p>
          <div style="text-align:center; margin-top:2rem">
            <button data-dismiss="modal" id="stayLogged" class="btn" @click="UIReset">Stay logged in</button>
          </div>
        </span>
      </div>
    </Modal>-->
    <!-- back-to-top -->
    <BackToTop></BackToTop>

    <!-- footer -->
    <Footer v-if="showFooter()"></Footer>
  </div>
</template>

<script>
/**
 * @author
 * @description
 * @module APP
 * @name  APP
 *
 */

import Navbar from "@/components/fixed/navbar/navbar";
import Footer from "@/components/fixed/footer";
import Banner from "@/components/fixed/banner";
import Modal from "@/components/base/modal";
import Notification from "@/components/base/notification";
import BackToTop from "@/components/fixed/back-to-top";
import { mapState, mapActions } from "vuex";

export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    Banner,
    Modal,
    Notification,
    BackToTop,
  },

  data() {
    return {
      // config values
      idleTime: 60 * 14, // The internal timer that tracks idle time, is reset on event. Set this to your timeout value in seconds
      idleCountdown: null, // Populated at runtime by idleTime value. This value decrease every second until timeout is reached
      idleTimeout: false, // Timeout status toggle
      UITime: 60, // Total time before UI performs action. Set this to your desired countdown to your users
      UICountdown: null, // Populated by uiTime on idleTimeout, UI countdown decreases every second until timeout is reached
      UITimeout: false, // UI timeout status toggle
    };
  },

  created() {
    console.log("[APP] Route name is: ", this.$route.name);

    // try auto login on refresh, also load user profile data
    this.$store.dispatch("tryAutoLogin");
  },

  // watch: {
  //   loggedIn() {
  //     if (!this.loggedIn) {
  //       // console.log("logged out, clear interval");
  //       clearInterval(this.setIdleTimer);
  //     } else {
  //       // console.log("logged in, start timer");
  //       this.idleTimeout = false;
  //       this.UITimeout = false;
  //     }
  //   }
  // },

  // ready: function () {
  //   this.startIdleCountdown();
  // },

  methods: {
    closeNotification() {
      let x = document.getElementById("notification-banner");
      x.style.display = "none";
    },

    showFooter() {
      const routeName = this.$route.name;
      const routeList = [
        "api-page",
        "api-docs-page",
        "api-docs-content-page",
        "api-docs-description-page",
        "terminal-page",
        "signin-page",
        "upgrade-page",
        "dash-board",
        "signup-page",
        "reset-password",
        "upgrage-page",
        "redirect",
      ];

      if (routeList.includes(routeName)) return false;
      const routePath = this.$route.path;
      if (routePath.startsWith("/app")) return false;
      return true;
    },
    showHeader() {
      const routeName = this.$route.name;
      const routeList = [
        "application-page",
        "terminal-page",
        "signin-page",
        "upgrade-page",
        "dash-board",
        "signup-page",
        "reset-password",
        "upgrage-page",
        "redirect",
      ];
      if (routeList.includes(routeName)) return false;
      const routePath = this.$route.path;
      // if (routePath.startsWith("/app")) return false;
      return true;
    },

    // ************************************* START IDLE COUNTDOWN ************************************* //

    // This starts the internal timer. The internal timer is started automatically
    // when user logged in. The internal timer will be reset everytime a mouse, click,
    // key event occurs, which means the user is active, on timeout, call
    // the countDown timer which is visible to the UI
    startIdleCountdown() {
      // $('#UICountdown').hide();                               // hides the UI warning window

      this.idleCountdown = this.idleTime; // initialize the timer with idle timeout config value
      this.setIdleTimer = setInterval(this.idleTimer, 1000); // starts the timer. setTimer is used to clear/reset idleTimer
    },

    // This is the method that counts down the idle time. Every 1000 ms an additional
    // second is removed from the timer. Once the count hits zero, the UI is
    // displayed and we call the uiCountDown
    idleTimer() {
      this.idleCountdown = this.idleCountdown - 1; // decrement idleCountdown every second

      if (!this.idleCountdown) {
        // if countdown is zero timeout is achieved
        clearInterval(this.setIdleTimer); // clear timer
        this.idleTimeout = !this.idleTimeout; // toggle the idle timeout status

        this.startUICountdown(); // start the UI timer
      }
    },

    // reset idle timer on mouse or key event.
    idleReset() {
      if (!this.idleTimeout && this.loggedIn) {
        // reset idle countdown only if idle timeout has not expired
        clearInterval(this.setIdleTimer); // reset the UI timer
        this.startIdleCountdown(); // start the idle countdown
      }
    },

    // ************************************* START UI COUNTDOWN ************************************* //

    // Starts the UI countdown, and displays the warning to user
    startUICountdown() {
      $("#UICountdown").modal({ backdrop: "static", keyboard: false }); // disable modal hide when click outside modal background
      $("#UICountdown").modal("show"); // display the UI warning window
      this.UICountdown = this.UITime; // initialize the UI timer with UI timeout config value
      this.setUITimer = setInterval(this.UITimer, 1000); // start UI timer. setUITimer is used to reset UITimer
    },

    // the countdown timer decrements the UICountdown value until zero
    UITimer() {
      this.UICountdown = this.UICountdown - 1; // decrement UI countdown every second

      if (!this.UICountdown) {
        // the countdown is complete, take action
        clearInterval(this.setUITimer); // reset the UI timer
        this.UITimeout = !this.UITimeout; // toggle UI timeout status. Use for future events

        this.countdownExpired(); // post UI countdown expiry events
      }
    },

    // If the UI reset button is clicked, we start from the beginning
    UIReset() {
      clearInterval(this.setUITimer); // reset the UI timer
      this.idleTimeout = !this.idleTimeout; // Toggle idleTimeout status
      this.startIdleCountdown(); // start the idle countdown
    },

    // ************************************* COUNTDOWN EXPIRED EVENTS ************************************* //

    countdownExpired() {
      $("#UICountdown").modal("hide");
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style lang="css">
/* import introjs css */
@import "./components/introjs/introjs.css";
@import "./components/introjs/themes/introjs-flattener.css";

/* import font */
@font-face {
  font-family: Jura;
  src: url("./assets/font/Jura-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: Jura;
  src: url("./assets/font/Jura-Bold.ttf") format("truetype");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: avenir;
  src: url("./assets/Avenir-Font/AvenirLTStd-Book.otf") format("opentype");
}
@font-face {
  font-family: Raleway;
  src: url("./assets/font/Raleway-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Raleway;
  src: url("./assets/font/Raleway-MediumItalic.ttf") format("truetype");
  font-weight: medium;
  font-style: italic;
}

/* app global styling */
#app {
  display: flex;
  flex-direction: column;
  background-color: white;
  font-family: avenir, Jura, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app::-webkit-scrollbar {
  display: none;
}

/* css for idle count down modal  */

#CountdownContent {
  font-family: Jura;
  color: #ffffff;
}

.idle-header {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}

.idle-info {
  letter-spacing: 0.59px;
  text-align: center;
  font-size: 20px;
}

#stayLogged {
  letter-spacing: 0.59px;
  background: #f5a623;
  font-weight: bold;
  border: 1px solid #f5a623;
  font-size: 20px;
  color: #4a4a4a;
  width: 200px;
}

/* App banner Styling */
.notification {
  padding: 0.2rem 1rem;
  background: rgb(21, 177, 0);
  background: radial-gradient(
    circle,
    rgba(21, 177, 0, 1) 52%,
    rgba(39, 113, 16, 1) 96%
  );
  width: 100%;
  color: white;
  text-align: center;
  font-weight: bold;
}

.close-banner {
  padding: auto 0.2rem !important;
  position: absolute;
  right: 0;
  top: 0;
  height: auto;
  background-color: transparent;
}

/* App Animation Styling */
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.2s;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(-100%);
}

/* Typography Styling */
p {
  margin-bottom: 0;
}

/* Basic Components Styling */
button:focus {
  outline: none;
  box-shadow: none;
  cursor: pointer;
}

/* Documentation Page Response JSON Preview Styling*/
.table-component__table {
  width: 100% !important;
}

code.hljs.javascript {
  background-color: rgba(20, 34, 45, 0.73) !important;
}

.hljs-string {
  color: #19e2cd;
}

.hljs-number {
  color: white;
}

/* Advertising Page Global Styling */
/* Carousel */

.VueCarousel-dot {
  background-color: #dee2e6 !important;
}

.VueCarousel-dot--active {
  background-color: #2f4552 !important;
}
.VueCarousel-dot:focus {
  outline: 0 !important;
}

.VueCarousel-dot-container {
  margin-top: 0 !important;
}

.VueCarousel-navigation-button {
  height: 100%;
}

.VueCarousel-navigation-button:focus {
  border: none !important;
  outline: none !important;
}

.VueCarousel-navigation-button:hover {
  background-color: #d8d8d8 !important;
}

.VueCarousel-navigation-button.VueCarousel-navigation--disabled:hover {
  background-color: transparent !important;
}

.check-it-out {
  color: white;
  text-decoration: none;
  border-bottom: 1px solid white;
  font-weight: bold;
}

.check-it-out:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue